import { shallowEqual } from 'react-redux';

import useMultiplexListingFlow from '../../../../hooks/useMultiplexListingFlow';
import { useSelector } from '../../../../selectors/useSelector';

import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

import LeaseTermsFormField from './LeaseTermsFormField';
import RentersInsuranceFieldSet from './RentersInsuranceFieldSet';

const baseBodyText = `Help renters decide if your property’s a good fit by including key lease details like duration, fees and utility costs, and other policies.`;

const FormSectionContainer = () => {
  const { isInMultiplexListingFlow } = useMultiplexListingFlow();

  const { isEligibleForIsRentersInsuranceRequiredQuestion } = useSelector((state) => {
    return {
      isEligibleForIsRentersInsuranceRequiredQuestion:
        state.properties.currentProperty?.rentersInsurance?.isEligibleForIsRentersInsuranceRequiredQuestion,
    };
  }, shallowEqual);

  return (
    <WizardFormSectionContainer isInMultiplexListingFlow={Boolean(isInMultiplexListingFlow)}>
      {isInMultiplexListingFlow === false && (
        <WizardHeading level={1} textStyle="heading-sm">
          What should renters know about the lease terms?
        </WizardHeading>
      )}

      <WizardBody>{baseBodyText}</WizardBody>

      <LeaseTermsFormField />

      {isEligibleForIsRentersInsuranceRequiredQuestion && <RentersInsuranceFieldSet />}
    </WizardFormSectionContainer>
  );
};

export default FormSectionContainer;
